import { NavKey, CrateType } from "@screens/Returns/types";

export const selectReturnsData = (state: any) => state.returns?.data;
export const selectReturnDataByType = (state: any, navKey: NavKey) =>
  state.returns?.data?.[navKey];
export const selectLoading = (state: any) => state.returns?.loading;
export const selectError = (state: any) => state.returns?.error;

export const selectReturnCratesList = (
  state: any,
  navKey: NavKey,
  crateType: CrateType
) =>
  crateType === "CRATES"
    ? state.returns.data?.["returnCratesList"]?.[navKey]
    : state.returns.data?.["returnPackedCratesList"]?.[navKey];
